import { render, staticRenderFns } from "./InformationRequestsPageHeader.vue?vue&type=template&id=4bba88fc"
import script from "./InformationRequestsPageHeader.vue?vue&type=script&lang=js"
export * from "./InformationRequestsPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports